import { array, number, object, string, } from 'yup';
import { PaymentPlanBrandingThemeFilterType, PaymentPlanFirstPaymentDate, PaymentPlanFrequency, PaymentPlanSurchargeUnit, } from '../../models';
export const paymentPlanConfigSchema = object({
    maxNumberOfPayments: number()
        .min(2)
        .max(400)
        .required(),
    firstPaymentDates: array()
        .of(string().oneOf(Object.values(PaymentPlanFirstPaymentDate)))
        .min(1)
        .required(),
    surchargeUnit: string().nullable().oneOf(Object.values(PaymentPlanSurchargeUnit)),
    surchargeCents: number().when('surchargeUnit', {
        is: PaymentPlanSurchargeUnit.FixedAmountCents,
        then: s => s
            .min(1, `Fixed amount must be greater than 1 when surcharge enabled`)
            .required(`Fixed amount is required when surcharge fixed amount enabled`)
            .typeError('Fixed amount can only be a number'),
        otherwise: s => s.nullable(),
    }),
    surchargePercent: number().when('surchargeUnit', {
        is: PaymentPlanSurchargeUnit.Percent,
        then: s => s
            .min(0.1, `Percent must be at least 0.1% when surcharge enabled`)
            .max(1000, `Percent cannot be more than 1000%`)
            .test('max-3-decimal-places', 'Percent can have at most 3 decimal places', value => {
            if (value == null)
                return true;
            if (typeof value !== 'number' || Number.isNaN(value))
                return false;
            const decimalPart = value.toString().split('.')[1];
            return !decimalPart || decimalPart.length <= 3;
        })
            .required(`Percent is required when surcharge percent enabled`)
            .typeError('Percent can only be a number'),
        otherwise: s => s.nullable(),
    }),
    externalSurchargeAccountCode: string().when('surchargeUnit', {
        is: (val) => val === PaymentPlanSurchargeUnit.FixedAmountCents || val === PaymentPlanSurchargeUnit.Percent,
        then: s => s
            .min(1, `Account code is required when surcharge is enabled`)
            .required(`Account code is required when surcharge is enabled`),
        otherwise: s => s.nullable(),
    }),
    minInvoiceDaysOverdue: number().nullable(),
    maxInvoiceDaysOverdue: number().when('minInvoiceDaysOverdue', {
        is: (val) => val != null,
        then: s => s
            .nullable()
            .test('gte-minInvoiceDaysOverdue', 'max invoice days overdue must be greater than or equal to min invoice days overdue', function (value) {
            const { minInvoiceDaysOverdue } = this.parent;
            if (value == null || minInvoiceDaysOverdue == null)
                return true;
            return value >= minInvoiceDaysOverdue;
        }),
        otherwise: s => s.nullable(),
    }),
    brandingThemeFilterType: string().nullable().oneOf([...Object.values(PaymentPlanBrandingThemeFilterType), null]),
    brandingThemeIds: array().of(string().required()).when('brandingThemeFilterType', {
        is: (val) => !!val,
        then: s => s.min(1, `Select at least one branding theme`).required(`Select at least one branding theme`),
        otherwise: s => s.nullable(),
    }),
    frequencyType: string().oneOf(Object.values(PaymentPlanFrequency)).required(),
});
//# sourceMappingURL=paymentPlanConfig.js.map